module.exports = __webpack_public_path__ + "static/media/iphone_comp_dark.3c9f26dd.svg";